import React from 'react';
import Wave from 'react-wavify';
import Header from './Header';
import Footer from './Footer';
import AboutUs from './AboutUs';
import AboutPage from './AboutPage';
import Coding from './Coding';
import Intro from './Intro';
import { ChakraProvider } from '@chakra-ui/react';

function Home() {
  return (
    <ChakraProvider>
      <div className="App">
        <Header></Header>
        {/* <Wave fill='blue'
          paused={false}
          options={{
            height:20,
            amplitude:40,
            speed:0.20,
            points:4
          }}/> */}
        <div className="App-example">
        <AboutUs/>
        <AboutPage/>
        <Coding/>
        </div>
        <Footer/>
      </div>
    </ChakraProvider>
  )
}

export default Home;